import { usuariosDB } from './index'

// ── Hashing ───────────────────────────────────────────────────────────────────

function generarSalt() {
  return Array.from(crypto.getRandomValues(new Uint8Array(16)))
    .map(b => b.toString(16).padStart(2, '0')).join('')
}

async function hashPBKDF2(pin, salt) {
  const key = await crypto.subtle.importKey(
    'raw',
    new TextEncoder().encode(String(pin)),
    { name: 'PBKDF2' },
    false,
    ['deriveBits']
  )
  const bits = await crypto.subtle.deriveBits(
    { name: 'PBKDF2', salt: new TextEncoder().encode(salt), iterations: 100000, hash: 'SHA-256' },
    key,
    256
  )
  return Array.from(new Uint8Array(bits)).map(b => b.toString(16).padStart(2, '0')).join('')
}

// Solo para migración de usuarios creados antes de PBKDF2
async function hashSHA256Legacy(pin) {
  const data = new TextEncoder().encode(String(pin))
  const hash = await crypto.subtle.digest('SHA-256', data)
  return Array.from(new Uint8Array(hash)).map(b => b.toString(16).padStart(2, '0')).join('')
}

async function crearPinHash(pin) {
  const salt = generarSalt()
  const hash = await hashPBKDF2(pin, salt)
  return `pbkdf2:${salt}:${hash}`
}

// ── Exports ───────────────────────────────────────────────────────────────────

export async function hayUsuarios() {
  const result = await usuariosDB.allDocs({ limit: 1 })
  return result.rows.length > 0
}

export async function obtenerUsuarios() {
  const result = await usuariosDB.allDocs({ include_docs: true })
  return result.rows.map(r => r.doc).filter(d => !d._id.startsWith('_design'))
}

export async function crearUsuario(nombre, rol, pin) {
  const pinHash = await crearPinHash(pin)
  return usuariosDB.put({
    _id: `usuario_${Date.now()}`,
    nombre,
    rol,
    pinHash,
    activo: true,
    creadoEn: new Date().toISOString(),
  })
}

export async function verificarPin(userId, pin) {
  const usuario = await usuariosDB.get(userId)

  if (usuario.pinHash.startsWith('pbkdf2:')) {
    const [, salt, expectedHash] = usuario.pinHash.split(':')
    const hash = await hashPBKDF2(pin, salt)
    return hash === expectedHash ? usuario : null
  }

  // Migración automática: usuario con hash SHA-256 antiguo
  const legacyHash = await hashSHA256Legacy(pin)
  if (legacyHash === usuario.pinHash) {
    usuario.pinHash = await crearPinHash(pin)
    await usuariosDB.put(usuario)
    return usuario
  }
  return null
}

export async function actualizarUsuario(usuario) {
  return usuariosDB.put(usuario)
}

export async function cambiarPin(userId, nuevoPin) {
  const usuario = await usuariosDB.get(userId)
  usuario.pinHash = await crearPinHash(nuevoPin)
  return usuariosDB.put(usuario)
}

export async function eliminarUsuario(usuario) {
  return usuariosDB.remove(usuario)
}
